export default __webpack_public_path__ + "static/media/regulatory--no-turn-on-red--g2.b82499bd.png";